import { Button, Divider, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import ViewActiveKanban from '../../../components/Comman/BinMaststerTable';

const ViewCardDataPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [seletedLocation, setSelectedLocation]= useState();

    const getDecodedQueryString = () => {
        setSelectedLocation(decodeURIComponent(location.search.substring(1)));
        return decodeURIComponent(location.search.substring(1));
    };

    useEffect(() => {
        console.log('Raw Query String:', getDecodedQueryString());
        
    }, [location.search]);
    console.log(seletedLocation);

    const handleArrowClick = () => {
        navigate('/eol-dashboard');
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />
                    View {seletedLocation}
                </Typography.Title>

            </div>
            <Divider style={{ marginTop: 8 }} />
            <ViewActiveKanban />

        </>
    )
}


export default ViewCardDataPage